<template>
  <div class="modal_wrapper active">
    <competitor-keywords-modal
      v-if="showCompetitorKeywordsModal"
      :competitor="selectedCompetitor"
    />
    <div class="modal_window white_box create_report_modal">
      <div class="heading_wrapper">
        <h3 class="heading">
          Here are some potential competitors
        </h3>
        <button
          class="close_modal close_btn"
          @click="closeModal()"
        >
          <svg
            fill="none"
            height="32"
            viewBox="0 0 32 32"
            width="32"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M25 7L7 25"
              stroke="#040707"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
            />
            <path
              d="M25 25L7 7"
              stroke="#040707"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
            />
          </svg>
        </button>
      </div>

      <div class="desc">
        Review the competitors listed below and try to select those who are most similar to your business,
        as these will provide the best new keyword suggestions.
        These websites are based on your chosen keywords in the platform.
      </div>

      <div
        v-if="serpSuggestedCompetitors.length > 1"
        class="more_button"
      >
        <span
          class="additional_suggestions"
          @click="additionalSuggestions"
        >
          Want to try different suggestions?
        </span>
      </div>

      <accordion-transition>
        <div
          v-if="competitor_url"
          class="confirmation"
        >
          We've added {{ competitor_url }} to your competitors
        </div>
      </accordion-transition>
      <accordion-transition>
        <div
          v-if="error"
          class="error"
          v-html="error"
        />
      </accordion-transition>

      <table class="competitors_table head">
        <thead>
          <tr>
            <td>
              Competitor
            </td>
            <td>
              Matching keywords
            </td>
            <td>
            &nbsp;
            </td>
          </tr>
        </thead>
      </table>
      <div class="table_body_wrap">
        <table class="competitors_table">
          <tbody>
            <tr
              v-for="(competitor, index) in limitedSuggestions"
              :key="index"
            >
              <td class="keyword">
                {{ competitor.domain }}
              </td>
              <td>
                <a
                  class="matching_keywords tooltipster"
                  href="javascript:;"
                  title="Click to view keywords"
                  @click="showCompetitorKeywordsModal = true; selectedCompetitor = competitor;"
                >
                  {{ competitor.count }} matching keywords
                </a>
              </td>
              <td>
                <button
                  :disabled="loading"
                  class="row_button"
                  @click="add(competitor, index)"
                >
                  <i
                    v-if="adding_competitor === index"
                    class="fas fa-spinner fa-spin"
                  />
                  <svg
                    v-else
                    fill="none"
                    height="14"
                    viewBox="0 0 14 14"
                    width="14"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2.1875 7H11.8125"
                      stroke="#37B2A8"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.5"
                    />
                    <path
                      d="M7 2.1875V11.8125"
                      stroke="#37B2A8"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                    />
                  </svg>
                  <span v-html="adding_competitor === index ? 'Adding' : 'Add competitor'" />
                </button>
              </td>
            </tr>
            <tr>
              <td
                v-if="suggestedCompetitors.length === 0"
                class="no_results text-center"
                colspan="3"
              >
                Sorry, we couldn't find any suggested competitors for your website
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import CompetitorKeywordsModal from './CompetitorKeywordsModal.vue';
import AccordionTransition from './../../../../reports/components/global/transitions/AccordionTransition.vue';
import Swal from "sweetalert2";

export default {
  components: {
    AccordionTransition,
    CompetitorKeywordsModal
  },
  props: {},
  data() {
    return {
      bulkKeywords: '',
      loading: false,
      visibleRows: 20,
      adding_competitor: null,
      competitor_url: null,
      showCompetitorKeywordsModal: false,
      error: null,
    }
  },
  computed: {
    ...mapState('competition', [
      'suggestedCompetitors',
      'serpSuggestedCompetitors'
    ]),
    limitedSuggestions() {
      return this.suggestedCompetitors.slice(0, this.visibleRows);
    }
  },
  mounted() {
    let table = document.querySelector('.table_body_wrap');
    table.onscroll = () => {
      let scrollTop = table.scrollTop;
      let scrollHeight = table.scrollHeight;
      let clientHeight = table.clientHeight;
      let scrollPercent = (scrollTop / (scrollHeight - clientHeight)) * 100;
      if (scrollPercent > 90) {
        this.visibleRows += 50;
      }
    };
  },
  methods: {
    ...mapActions('keywordIdeas', [
      'fetchSuggestions',
      'setFilter',
    ]),
    ...mapActions('competition', [
      'addCompetitor',
      'openSerpSuggestedCompetitorsModal',
      'closeSuggestedCompetitorsModal',
    ]),
    add(competitor, index) {
      this.loading = true;
      this.adding_competitor = index;
      this.addCompetitor(competitor.website)
          .then((response) => {
            this.competitor_url = competitor.simple_url;
            this.adding_competitor = null;
            this.loading = false;
            this.fetchSuggestions().then(() => {
              this.setFilter({key: 'competitorFilter', value: response.simple_url});
            });
            setTimeout(() => {
              this.competitor_url = null;
            }, 3000);
          })
          .catch(response => {
            this.adding_competitor = null;
            this.loading = false;
            const error = response.data;
            if (response.status === 422) {
              this.error = error.message;
              return;
            }

            let {title, message} = error;
            if (response.status >= 500) {
              title = 'Whoops!';
              message = 'Something went wrong. Please try again.';
            }

            Swal.fire({
              icon: 'warning',
              title: title,
              html: message,
            });
          });
    },
    additionalSuggestions() {
      this.closeSuggestedCompetitorsModal();
      this.openSerpSuggestedCompetitorsModal();
    },
    closeModal() {
      this.closeSuggestedCompetitorsModal();
    }
  }
}
</script>

<style scoped>
.modal_wrapper {
  z-index: 100;
  position: fixed;
  display: flex;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  -webkit-transition: .3s;
  -o-transition: .3s;
  transition: .3s;
  padding: 5vh 0;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.2);
}

.modal_wrapper > .modal_wrapper {
  z-index: 101;
}

.modal_wrapper::-webkit-scrollbar {
  width: 0;
}

.modal_window {
  position: relative;
  margin: auto;
  max-width: 900px;
  width: 90vw;
  z-index: 100;
  -webkit-box-shadow: 0px 10px 30px rgba(4, 7, 7, 0.2);
  box-shadow: 0px 10px 30px rgba(4, 7, 7, 0.2);
  border-radius: .75rem;
}

.heading_wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.close_btn {
  height: auto;
}

.heading {
  font-weight: 700;
  line-height: 1.42;
  letter-spacing: -0.042em;
  color: #040707;
  font-size: 1.5rem;
}

.desc {
  margin-bottom: 10px;
}

.more_button {
  display: flex;
  justify-content: flex-end;
}

.additional_suggestions {
  cursor: pointer;
  color: var(--primary-color);
  font-size: 12px;
}

.confirmation {
  background: #DFF5EE;
  font-size: .8rem;
  margin: 5px auto;
  border-radius: 3px;
  padding: 5px 10px;
  transition: .3s;
}

.error {
  font-size: .8rem;
  margin: 5px auto;
  border-radius: 3px;
  padding: 5px 10px;
  transition: .3s;
  margin-bottom: 10px;
  background: #EBBFBE;
}

.competitors_table {
  width: 100%;
  border-spacing: 0;
  border-collapse: collapse;
}

.competitors_table.head {
  width: calc(100% - 15px);
  height: 15%;
}

.competitors_table thead td {
  padding: 1rem 1rem 1rem;
}

.competitors_table thead td {
  font-weight: 500;
  font-size: 16px;
  line-height: 26px;
  letter-spacing: -0.25px;
  margin-right: 0.25rem;
}

.table_body_wrap {
  width: 100%;
  overflow-y: scroll;
  max-height: 60vh;
}

.sort_title {
  cursor: pointer;
  display: flex;
  align-items: center;
}

.sort_title.center {
  justify-content: center;
}

.sort_title.desc i {
  transform: rotate(180deg);
}

.competitors_table tr td:first-of-type {
  width: 55%;
}

.competitors_table tr td:nth-of-type(2) {
  width: 25%;
  text-align: center;
}

.competitors_table tr td:nth-of-type(3) {
  padding: 0;
  text-align: center;
}

.competitors_table tbody tr:nth-of-type(2n+1) {
  background: #FBFAFA;
}

.competitors_table tbody tr td {
  padding: 1rem;
}

.matching_keywords {
  background-color: #E4FAFD;
  color: #1993AE;
  padding: 0.25rem 0.5rem;
  font-size: 10px;
  line-height: 1.3;
  letter-spacing: -0.1px;
  border-radius: 6px;
  margin: 2px;
  cursor: pointer;
}

.row_button {
  height: 30px;
  cursor: pointer;
  border-radius: 6px;
  border: 2px solid #37B2A8;
  color: #37B2A8;
  margin-right: 1rem;
  line-height: 1.4rem;
}

.row_button svg {
  margin-top: -0.1rem;
}

.row_button .fas,
.row_button svg {
  margin-right: 0.5rem;
}
</style>
